/* eslint-disable security/detect-object-injection */
export const EXPERIMENTS = {
  INGRID_SEARCH: 'se-5',
} as const;

export function isInExperimentControl(
  experiments: Record<string, string> | undefined,
  experimentId: string,
  controlValue: string,
): boolean {
  return experiments?.[experimentId] === controlValue;
}

export function isInExperimentVariant(
  experiments: Record<string, string> | undefined,
  experimentId: string,
  variant: string,
): boolean {
  return experiments?.[experimentId] === variant;
}
